const MOD_SELECTOR = '[data-name="mods"]';
const VERSION_SELECTOR = '[data-name="versions"]';
const JAVA_VERSION_SELECTOR = '[data-name="javaVersion"]';
const JAVA_VERSION_WRAPPER = '[data-name="javaVersion-wrapper"]';

export interface ModificationVersion {
  id: string;
  version: string;
  build: string;
}

export interface ModificationMod {
  branch: string;
  image: string;
  memory: string;
  name: string;
  versions: ModificationVersion[];
}

export interface ModificationModOption {
  0: string;
  1: string;
  memory: string;
}

export class ModificationUI {
  public constructor(private $base: JQuery, public data: any) {
  }

  public onModChange(callback: (value: string, target: JQuery) => void) {
    this.$base.find(MOD_SELECTOR).on('change', (e: JQuery.TriggeredEvent) => {
      const val = e.currentTarget.value;
      callback(val, e.currentTarget);
    });
  }

  public getModsValue(): string {
    return this.$base.parents('[data-configuration-form]')
      .find(MOD_SELECTOR)
      .val()
      .toString();
  }

  public disableJavaVersion() {
    this.$base.parents('[data-configuration-form]')
      .find(JAVA_VERSION_SELECTOR).attr('disabled', 'disabled')
      .closest(JAVA_VERSION_WRAPPER)
      .hide('fast');
  }

  public enableJavaVersion() {
    this.$base.parents('[data-configuration-form]')
      .find(JAVA_VERSION_SELECTOR).removeAttr('disabled')
      .closest(JAVA_VERSION_WRAPPER)
      .show('fast');
  }

  public onVersionChange(callback: (value: string) => void) {
    this.$base.find(VERSION_SELECTOR).on('change', (e: JQuery.TriggeredEvent) => {
      const val = e.currentTarget.value;
      callback(val);
    });
  }

  public render(selectedMod: ModificationMod, mods: object, selectedVersion: number) {
    return new Promise((resolve) => {
      // reset mods and versions selects
      const modsElement = this.$base.find(MOD_SELECTOR).empty();
      const versionsElement = this.$base.find(VERSION_SELECTOR).empty();

      // populate mods select
      Object.values(mods).forEach((mod: ModificationModOption) => {
        const option = new Option(mod[1], mod[0], null, mod[0] == selectedMod?.branch);
        option.setAttribute('data-memory', mod.memory);
        modsElement.append(option);
      });

      // populate versions select
      selectedMod?.versions.forEach((version: ModificationVersion) => {
        const option = new Option(version.version, version.id, null, +version.id == selectedVersion);
        versionsElement.append(option);
      });

      resolve();
    });
  }

  public isTerraria(): boolean {
    return window.location.href.indexOf('terraria') > 0;
  }
}
